import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Disclosure, Menu, Transition} from '@headlessui/react'
import {Bars3Icon, BellIcon, XMarkIcon, ListBulletIcon, HomeIcon} from '@heroicons/react/24/outline'

import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
	addEventAttribute,
	adminEventCard,
	audienceButtons, MetaTags,
	setUniqueEventAttribute,
	smallEventCard,
	smallSchemaArtistCard,
	toastSuccess
} from "../../components/common/utilities";
import {ChevronDownIcon, MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";
import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
import {useTranslation} from "react-i18next";
import CreatePage from "../authentication/createUser";

function classNames(...classes: any[]) {
	return classes.filter(Boolean).join(' ')
}

export default function HowDoesItAllFitTogether() {
	const navigate = useNavigate();
	const logout = () => {
		window.location.href = '/logout';
	}
	const { t, i18n }:any = useTranslation('dashboard');



	type SchemaArtist = {
		[key: string]: any; // ?? variable key
		name: string;
	};
const [artistData, setArtistData] = useState<SchemaArtist>();

	const stopBouncing = () => {
		const el = document.getElementById("promo-icon");
		if (el) {
			el.classList.remove("animate-bounce");
		}
	}

	var date = new Date();
	useEffect(() => {
		setTimeout(() => stopBouncing(), 3500)
		//getPhotos();

	}, []);

	const pages = [

		{ name: 'Fyrir Fjölmiðla', href: '/forthemedia', current: true },
		{ name: 'Menningarumfjöllun', href: '/documentation/mediaiceland', current: false },
		{ name: t('gettingstarted'), href: '/gettingstarted', current: false },
	]

	return (<>
		{/*
        This example requires updating your template:

        ```
        <html class="h-full">
        <body class="h-full">
        ```
      */}

		<MetaTags
			title="Hvað getum við gert fyrir fjölmiðla?"
			description={'Snúum vörn í sókn gagnvart auglýsingum á samfélagsmiðlum og sækjum tekjurnar heim. Fáum fleiri síðuflettingar og veitum lesendum betri þjónustu.'}
			image="https://promogogo.com/cdn-cgi/image/fit=contain,width=400/https://media.promogogo.com/ymsirvidburdir/2024-08-26/ymsirvidburdir-3dd43861-6d71-4d23-8a76-2e20c565fcb0-formedia.png"
		/>

		<div
			className="max-w-6xl mx-auto px-4 py-8 bg-white">

			<div
				className="mx-auto md:grid md:grid-cols-2 ">

				<div className={'md:col-span-1'}>
					<div
						className="mt-2 ">

						<div className="lg:pr-4">
							<div className="lg:max-w-lg">
								<div className="flex">
									<a href={'/'}>
										<img
											id="promo-icon"
											className="h-16 w-auto animate-bounce"
											src="https://media.promogogo.com/ymsirvidburdir/2025-03-13/ymsirvidburdir-78662c7e-34ad-47cd-83fe-f73fbea5e36b-promo_heart_yellow_256px.png"
											alt="Promogogo"
										/></a>
								</div>
								<p className="text-base font-semibold leading-7 text-indigo-600">{t('howdoesthisallwork')}</p>
								<h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t('wanttosignup')}
								</h1>
								<p className="mt-6 text-xl leading-8 text-gray-700">
									{t('makesureyourevents')}

								</p>
							</div>
						</div>
					</div>
					<div
						className="mt-2">
						<div className="lg:pr-4">
							<div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
								<p>
									{t('itsallfreeexcept')}

								</p>

								<ul role="list" className="mt-8 space-y-8 text-gray-600">
									<li className="flex gap-x-3">
										<ListBulletIcon className="mt-1 h-5 w-5 flex-none text-indigo-600"
														aria-hidden="true"/>
										<span>
                    <strong className="font-semibold text-gray-900">{t('firstwasnothing')}</strong> {t('youasyou')}

                  </span>
									</li>
									<li className="flex gap-x-3">
										<ListBulletIcon className="mt-1 h-5 w-5 flex-none text-indigo-600"
														aria-hidden="true"/>
										<span>
                    <strong className="font-semibold text-gray-900">{t('homebythesea')}
                    </strong> {t('theonethatpaysthebills')}

                  </span>
									</li>

									<li className="flex gap-x-3">
										<ListBulletIcon className="mt-1 h-5 w-5 flex-none text-indigo-600"
														aria-hidden="true"/>
										<span>
											<strong className="font-semibold text-gray-900">{t('onemorenight')}</strong> {t('fullaccountscan')}</span>


									</li>
								</ul>
								<p className="mt-8">
									{t('eventsallover')}

								</p>

								{/*<div className="mt-10 flex items-center gap-x-6">
									<a
										href="/forthemedia"
										className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									>
										Miðlar
									</a>
									<a
										href="/documentation/mediaiceland"
										className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									>
										Umfjöllun
									</a>
									<a
										href="/documentation/admarketiceland"
										className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									>
										Tekjur
									</a>

								</div>*/}

							</div>
						</div>
					</div>
				</div>
				<div className={'md:col-span-1'}>
					<CreatePage/>
				</div>

			</div>
		</div>


	</>)
}
